<template>
    <div>
        <div class="contenedor-sh-mensaje" :class="verDato? 'd-flex justify-content-center':''">
            <!-- Contenedor imagen de secretario -->
            <div class="img_sh" :class="verDato? 'mr-0':''">
                <img src="@/assets/imagenes/imagen_secretario.jpg" alt="">
            </div>
            <!-- contenedor mensaje -->
            <div class="mensajesh_bienvenida" :class="verDato? 'alineacion':'mb-3'">
                <div :class="verDato? 'card-bienvenida':''">
                <!-- cuerpo de texto -->
                    <p :class="verDato? 'font mb-1':'mb-3'">Bienvenidos al Portal de Internet de la Secretaría de Hacienda del Estado de Chiapas; 
                        un sitio que hemos renovado con el único fin de servirte mejor, al acercarte los trámites 
                        y servicios de manera más rápida y sencilla.</p>  

                    <p :class="verDato? 'font mb-0':'mb-2'">Esta Administración encabezada por el Dr. Rutilio Escandón Cadenas le apuesta a la 
                    modernización tecnológica, pues es un factor de cambio en la forma que como gobierno 
                    le respondemos de manera eficiente a la demanda ciudadana.</p>
                        
                    <p :class="verDato? 'font mb-0':'mb-2'">Los que formamos parte del Equipo de la Secretaría de Hacienda del Estado de 
                    Chiapas, estamos comprometidos con el Proyecto de Gobierno 2018-2024 al promover 
                    la transparencia en el deber hacendario y con ello buscar el beneficio de nuestro bello 
                    Estado.</p>          
                    <p :class="verDato? 'font mb-0':'mb-2'">Reiteramos nuestro compromiso de seguir mejorando cada día, muchas gracias…</p>        
                    <div v-if="verDato">
                        <span class="dato-srio" style="text-align: left !important">Javier Jiménez Jiménez</span><br>
                        <span class="dato-srio" style="text-align: left !important">Secretario de Hacienda del Estado de Chiapas</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        verDato: false,
    },
}
</script>
<style scoped>
/* <!-- =====CONTENEDOR IMAGEN Y MENSAJE DEL SRIO===== --> */
.contenedor-sh-mensaje{
    display: flex;
    justify-content: flex-start;
}
/* Contenedor imagen de secretario */
.contenedor-sh-mensaje .img_sh{
    width: 25%;
    height: auto;
    margin-right: 1.5rem    
}
/* imagen */
.contenedor-sh-mensaje .img_sh img{
    width: 100%;    
    border-radius: 5px;
}
/* contenedor mensaje */
.contenedor-sh-mensaje .mensajesh_bienvenida{
    width: 65%;
    height: auto;
}


/* cuerpo de texto */
.contenedor-sh-mensaje .mensajesh_bienvenida p{
   font-size: 13.5pt;
   font-style: italic;
   font-weight: 300;
   text-align: justify;
   line-height: 1.8rem;
    margin-bottom: 3rem;
   
}
.contenedor-sh-mensaje .nombre-srio{
    /* color: #9d9d9d; */
    color: #6c757d;
    font-size: 15pt;
    font-weight: 500;
}
.dato-srio{
    font-weight: 500;
    font-size: 11.5pt;
}

/* estilos para home----------------------------------------- */
.card-bienvenida{
    border: 1px solid #ededed;
    padding: 1rem;
    background: #fff;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15) !important;
}
.font{ font-size: .88rem !important; }
.alineacion{
    display: flex;
    align-items: center;
}
/* fin estilos para home------------------------------------- */

@media only screen and (max-device-width : 900px){
    /* contenedor img y mensaje */
    .contenedor-sh-mensaje{
        flex-wrap: wrap;
    }
    /* Contenedor imagen de secretario */
    .contenedor-sh-mensaje .img_sh {
        display: flex;
        justify-content: center;
        width: 100%;
        height: auto;    
        margin-right: 0;
    }
    /* imagen */
    .contenedor-sh-mensaje .img_sh img{
        width: 70%;    
    }
    /* contenedor mensaje */
    .contenedor-sh-mensaje .mensajesh_bienvenida {      
        width: 100%;
        height: auto;
        margin-top: 1rem;
        /* text-align: center; */
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }  
    .contenedor-sh-mensaje .mensajesh_bienvenida p{
        margin-bottom: 1rem;
    }
}
</style>